const STORAGE_KEY = 'superoti.deviceRevokedNotice'

export const DEVICE_REVOKED_NOTICE =
  'Perangkat ini sudah tidak aktif karena akun diaktivasi di perangkat lain atau di-unbind Admin HO. Masukkan kode aktivasi baru.'

/** Disimpan di sessionStorage agar pesan bertahan melewati redirect ke halaman aktivasi. */
export function setDeviceRevokedNotice(message = DEVICE_REVOKED_NOTICE): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, message)
  } catch {
    // storage tidak tersedia; redirect tetap berjalan tanpa pesan
  }
}

export function consumeDeviceRevokedNotice(): string | null {
  try {
    const message = sessionStorage.getItem(STORAGE_KEY)
    if (message) sessionStorage.removeItem(STORAGE_KEY)
    return message
  } catch {
    return null
  }
}
